export const createDependencyString = (
  obj: Record<string, unknown> | undefined
): string => {
  if (!obj) return "";
  return Object.entries(obj)
    .sort((a, b) => a[0].localeCompare(b[0]))
    .reduce((acc, [key, value]) => acc + key + ":" + value + ",", "");
};
